import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-cycle
import { useFetch } from '../../../services/transports';
import { LabeledSelect } from '..';
import { searchLabelName } from '../../../api/systemManagement';

export const SearchLabelNameDropdown = ({
  label,
  id,
  onChange,
  withAsterisks,
  disabled,
  value,
  setValueAsObject
}) => {
  const { t } = useTranslation();
  const [ options, setOptions ] = useState([]);

  const [ { data }, fetchSearchLabelName ] = useFetch(
    searchLabelName,
    useCallback(response => {
      const container = response?.data?.container;
      if (container) {
        setOptions(
          container.map(i => ({
            value: i.labelId,
            text: i.labelName,
            item: i
          }))
        );
      }
    }, [])
  );

  const onSearchLabel = useCallback(query => {
    if (query) {
      fetchSearchLabelName({ SearchTerm: query.trim() });
    }
  }, [ fetchSearchLabelName ]);

  return (
    <LabeledSelect
      data-testid={ `${id}-types` }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearchLabel }
      searchDelay={ 1000 }
      options={ options }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatched') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear
      value={ value?.value || value }
      setValueAsObject={ setValueAsObject }
      placeholder={ t('fields.choose') }
    />
  );
};
